import LoaderAnimation from './LoaderAnimation'
import LoaderSkeleton from './LoaderSkeleton'

interface LoaderProps {
  inLoading: boolean
  type: 'page' | 'component'
  height?: number
}

function Loader({ inLoading, type, height }: LoaderProps) {
  return (
    <>
      {inLoading ? (
        type === 'component' ? (
          <LoaderSkeleton height={height} />
        ) : (
          <LoaderAnimation />
        )
      ) : null}
    </>
  )
}

export default Loader
